import { DataValidationError } from "constants/DataValidationError";
import {
  IsBoolean,
  IsNotEmpty,
  IsNumberString,
  IsNumber,
  IsOptional,
  MaxLength,
} from "class-validator";

export default class UpdateRoomReq {
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  roomId!: any;

  // Select の value は string で来る (MUI Select 都合)、server 側 @Type(() => Number) で受ける
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  @IsNumberString()
  shopId!: any;

  @MaxLength(64, {
    message: DataValidationError.DATA_IS_TOO_LONG,
    context: { constraint1: 64 },
  })
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  name!: string;

  @IsOptional()
  note: string | null = null;

  @IsOptional()
  @IsNumber()
  sort: number | null = null;

  @IsOptional()
  @IsBoolean()
  isActive = true;

  constructor(arg: any) {
    arg = arg || {};
    this.roomId = arg.roomId;
    this.shopId = arg.shopId;
    this.name = arg.name;
    this.note = arg.note ?? null;
    this.sort = arg.sort ?? null;
    this.isActive = arg.isActive ?? true;
  }
}
